import { setApiUrl } from 'api/helpers'
import { RESOURCE_ENDPOINT } from './config'
import * as types from './types'

export const getSearchStream = async (
  search: string,
  conversationId: string,
  siteId: string,
  signal?: AbortSignal
): Promise<Response> => {
  const searchParams: types.TGetSearchStreamQueryParams = {
    q: search,
    siteId,
    conversationId
  }

  const url = setApiUrl(RESOURCE_ENDPOINT, { searchParams })

  return fetch(url, { signal })
}
